import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitNow() {
    const previousFrame = document.getElementById("migration_previous_result")
    if (previousFrame) {
      previousFrame.innerHTML = ""
      previousFrame.classList.add("hidden")
    }

    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
      return
    }

    this.element.submit()
  }
}
